import { FC, useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SCUIButton } from "../../../../atomic/atoms";
import { SCUIGeneralDrawerHeader } from "../../../../atomic/molecules";
import { SCUIConfirmDialog } from "../SCUIConfirmDialog/SCUIConfirmDialog";
import { initialState } from "../../LocalizationManagement.helper";
import { LOC, locCls, locConfirmDialogE2e } from "../../localizationManagement.classes";

interface IProps {
  selectedRow?: any;
  onClose?: any;
  setDatas?: any;
  datas?: any;
  refresh?: any;
  filterInput?: any;
}
export const SCUILocalizationEdit: FC<IProps> = ({
  selectedRow,
  onClose,
  setDatas,
  datas,
  refresh,
  filterInput,
}) => {
  const { t } = useTranslation();
  const [drawerConfirmOpen, setDrawerConfirmOpen] = useState(false);
  const [updatedValue, setUpdatedValue] = useState(initialState.updatedKeyword);

  const handleClickOpenConfirmDialog = () => {
    setDrawerConfirmOpen(true);
  };
  const handleCloseConfirmDialog = () => {
    setDrawerConfirmOpen(false);
  };
  useEffect(() => {
    setUpdatedValue({ ...updatedValue, keyword: selectedRow.keyword });
  }, []);
  return (
    <form
      onSubmit={(e: any) => {
        e.preventDefault();
        handleClickOpenConfirmDialog();
      }}
    >
      <div className={locCls('commentFilterContainer', LOC.editDrawerBody)}>
        <SCUIConfirmDialog
          open={drawerConfirmOpen}
          onClose={handleCloseConfirmDialog}
          selectedRow={selectedRow}
          dialogContent={t("general.updateConfirmationText")}
          buttonNameAccept={t("general.yes")}
          buttonNameReject={t("general.no")}
          actionType="update"
          closeEditModal={onClose}
          datas={datas}
          setDatas={setDatas}
          updatedRow={updatedValue}
          refresh={refresh}
          filterInput={filterInput}
          e2eClassNames={locConfirmDialogE2e}
        ></SCUIConfirmDialog>

        <Grid container spacing={1}>
          <SCUIGeneralDrawerHeader
            header={t("general.localizationUpdate")}
            onClose={onClose}
            rootClassName={LOC.editDrawerHeaderRoot}
            titleClassName={LOC.editDrawerHeaderTitle}
            closeIconClassName={LOC.inputIconEditDrawerClose}
          />
          <Grid
            size={{
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12
            }}>
            <Grid
              className={LOC.editDrawerAppField}
              style={{ marginTop: "1rem" }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <TextField
                className={LOC.inputTextEditAppReadonly}
                label={t("general.app")}
                defaultValue={selectedRow && selectedRow.applicationNames}
                variant="outlined"
                type="text"
                id="appText"
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              className={LOC.editDrawerKeywordsField}
              style={{ marginTop: "2rem" }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <TextField
                className={LOC.inputTextEditKeywordsReadonly}
                id="keywords"
                defaultValue={selectedRow && selectedRow.keyword}
                type="text"
                label={t("general.keywords")}
                fullWidth
                disabled
              />
            </Grid>
            <Grid
              className={LOC.editDrawerValueField}
              style={{ marginTop: "2rem" }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <TextField
                className={LOC.inputTextEditKeywordValue}
                id="keywordValue"
                defaultValue={selectedRow && selectedRow.keywords}
                type="text"
                label={t("general.keyword")}
                fullWidth
                onChange={(event) => {
                  setUpdatedValue({
                    ...updatedValue,
                    keyword: event.target.value,
                  });
                }}
              />
            </Grid>
          </Grid>
           
            <Grid
              className={LOC.editDrawerFooter}
              style={{ 
                display: 'flex', 
                justifyContent: 'flex-end', 
                marginTop: '20px',
                marginBottom: '20px'
              }}
              size={{
                xs: 12,
                md: 12,
                lg: 12,
                xl: 12
              }}>
              <SCUIButton 
                className={LOC.inputButtonEditUpdate}
                text={t('general.update')} 
                type="primary" 
                sizeType="fixed" 
                size={"m"}
                style={{width: 140}}
              />
            </Grid>
          </Grid>
      </div>
    </form>
  );
};
